import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { Emisor } from "../models/generarArchivoProcesosMasivos";

const getEmisor = async () => {
    const response: AxiosResponse<ListResponseDto<Emisor>> = await axiosInstance.get(`siscred-api-transversal/v1/instituciones/obtener-datos-emisor`);
    return response;
}

export {
    getEmisor
}